/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Session_ActionsInputs */

const en_ui_session_actions = /** @type {(inputs: Ui_Session_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session actions`)
};

const de_ui_session_actions = /** @type {(inputs: Ui_Session_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheitsaktionen`)
};

/**
* | output |
* | --- |
* | "Session actions" |
*
* @param {Ui_Session_ActionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_session_actions = /** @type {((inputs?: Ui_Session_ActionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Session_ActionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_session_actions(inputs)
	return de_ui_session_actions(inputs)
});